"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var antd_1 = require("antd");
var AttributeCombo_1 = __importDefault(require("../AttributeCombo/AttributeCombo"));
var OperatorCombo_1 = __importDefault(require("../OperatorCombo/OperatorCombo"));
var TextFilterField_1 = __importDefault(require("../TextFilterField/TextFilterField"));
var NumberFilterField_1 = __importDefault(require("../NumberFilterField/NumberFilterField"));
require("./ComparisonFilter.css");
var BoolFilterField_1 = __importDefault(require("../BoolFilterField/BoolFilterField"));
var _get = require('lodash/get');
var _cloneDeep = require('lodash/cloneDeep');
var _isEqual = require('lodash/isEqual');
var _isEmpty = require('lodash/isEmpty');
var _isFunction = require('lodash/isFunction');
/**
 * UI for a ComparisonFilter consisting of
 *
 *   - A combo to select the attribute
 *   - A combo to select the operator
 *   - An input field for the value
 */
var ComparisonFilter = /** @class */ (function (_super) {
    __extends(ComparisonFilter, _super);
    function ComparisonFilter(props) {
        var _this = _super.call(this, props) || this;
        _this.operatorsMap = {
            string: ['==', '*=', '!='],
            number: ['==', '!=', '<', '<=', '>', '>='],
            boolean: ['==', '!=']
        };
        /**
         * Retuns the state part showing which value UI should be rendered according to attribute type.
         *
         * @param {string} The attribute name to get the value visalization state for
         */
        _this.getValueFieldVis = function (attrName) {
            // read out attribute type
            var attrType = _get(_this.props, "internalDataDef.schema.properties[" + attrName + "].type");
            // for string and any non-specified type we show a text field
            var valueFieldVis = {
                textFieldVisible: true,
                numberFieldVisible: false,
                boolFieldVisible: false
            };
            // visibility due to attribute's type
            if (attrType === 'number') {
                valueFieldVis = {
                    textFieldVisible: false,
                    numberFieldVisible: true,
                    boolFieldVisible: false
                };
            }
            else if (attrType === 'boolean') {
                valueFieldVis = {
                    textFieldVisible: false,
                    numberFieldVisible: false,
                    boolFieldVisible: true
                };
            }
            return valueFieldVis;
        };
        /**
         * Handler function, which is executed, when to underlying filter attribute changes.
         *
         * Changes the input field for the filter value and stores the appropriate attribute name as member.
         */
        _this.onAttributeChange = function (newAttrName) {
            var _a = _this.props, internalDataDef = _a.internalDataDef, onFilterChange = _a.onFilterChange, validators = _a.validators;
            var filter = _cloneDeep(_this.state.filter);
            filter[1] = newAttrName;
            var valueFieldVis = _this.getValueFieldVis(newAttrName);
            _this.setState(valueFieldVis);
            if (internalDataDef) {
                // read out attribute type
                var attrDefs = internalDataDef.schema.properties;
                var attrType = attrDefs[newAttrName].type;
                _this.setState({ attribute: newAttrName });
                // reset the filter value when the attribute type changed
                if (attrType !== _this.state.attributeType) {
                    _this.setState({
                        value: null,
                        // preserve the attribute type to compare with new one
                        attributeType: attrType,
                        allowedOperators: _this.operatorsMap[attrType]
                    });
                }
            }
            var isValid = validators.attribute(newAttrName);
            var validationStateNew = __assign({}, _this.state.validateStatus, { attribute: isValid ? 'success' : 'error' });
            _this.setState({
                filter: filter,
                validateStatus: validationStateNew
            }, function () {
                if (onFilterChange) {
                    onFilterChange(filter);
                }
            });
        };
        /**
         * Handler function, which is executed, when to underlying filter operator changes.
         *
         * Stores the appropriate operator as member.
         */
        _this.onOperatorChange = function (newOperator) {
            var onFilterChange = _this.props.onFilterChange;
            var filter = _cloneDeep(_this.state.filter);
            filter[0] = newOperator;
            _this.setState({ filter: filter });
            var isValid = _this.props.validators.operator(newOperator);
            var validationStateNew = __assign({}, _this.state.validateStatus, { operator: isValid ? 'success' : 'error' });
            _this.setState({
                validateStatus: validationStateNew,
                operator: newOperator
            }, function () {
                if (onFilterChange) {
                    onFilterChange(filter);
                }
            });
        };
        /**
         * Handler function, which is executed, when to underlying filter value changes.
         *
         * Stores the appropriate filter value as member.
         */
        _this.onValueChange = function (newValue) {
            var onFilterChange = _this.props.onFilterChange;
            var filter = _cloneDeep(_this.state.filter);
            filter[2] = newValue;
            // validate value fields
            var validationRes = _this.props.validators.value(newValue, _this.props.internalDataDef, _this.state.attribute);
            var validationStateNew = __assign({}, _this.state.validateStatus, { value: validationRes.isValid ? 'success' : 'error' });
            _this.setState({
                validateStatus: validationStateNew,
                filter: filter,
                valueValidationHelpString: validationRes.errorMsg
            }, function () {
                if (onFilterChange) {
                    onFilterChange(filter);
                }
            });
        };
        /**
         * Function that validates given filter in props
         */
        _this.validateFilter = function () {
            var _a = _this.props, filter = _a.filter, validators = _a.validators, onValidationChanged = _a.onValidationChanged;
            if (!filter || !Array.isArray(filter)) {
                _this.setState({
                    validateStatus: {
                        attribute: 'error',
                        operator: 'error',
                        value: 'error'
                    }
                });
                return;
            }
            var validationRes = validators.value(filter[2], _this.props.internalDataDef, _this.state.attribute);
            var validateStatus = {
                attribute: validators.attribute(filter[1]) ? 'success' : 'error',
                operator: validators.operator(filter[0]) ? 'success' : 'error',
                value: validationRes.isValid ? 'success' : 'error'
            };
            _this.setState({
                validateStatus: validateStatus
            }, function () {
                if (_isFunction(onValidationChanged)) {
                    onValidationChanged(validateStatus);
                }
            });
        };
        var _a = _this.props, filter = _a.filter, internalDataDef = _a.internalDataDef, valueValidationHelpString = _a.valueValidationHelpString;
        if (filter) {
            // build UI by passed in filter object
            var attrName = filter[1];
            var stateParts = {
                attribute: attrName,
                operator: filter[0],
                value: filter[2],
                filter: _this.props.filter,
                validateStatus: {
                    attribute: attrName ? 'success' : 'error',
                    operator: filter[0] ? 'success' : 'error',
                    value: filter[2] ? 'success' : 'error'
                },
                valueValidationHelpString: valueValidationHelpString
            };
            _this.state = stateParts;
            // read out attribute type
            if (internalDataDef) {
                var attrDefs = internalDataDef.schema.properties;
                var attribute = attrDefs[attrName];
                if (attribute) {
                    var attrType = attrDefs[attrName].type;
                    stateParts.attributeType = attrType;
                    stateParts.allowedOperators = _this.operatorsMap[attrType];
                }
            }
            var valueFieldVis = _this.getValueFieldVis(attrName);
            _this.state = Object.assign(stateParts, valueFieldVis);
        }
        else {
            _this.state = {
                textFieldVisible: true,
                numberFieldVisible: false,
                boolFieldVisible: false,
                attribute: '',
                operator: undefined,
                value: null,
                filter: ComparisonFilter.defaultProps.filter,
                allowedOperators: ['==', '*=', '!=', '<', '<=', '>', '>='],
                validateStatus: {
                    attribute: 'error',
                    operator: 'error',
                    value: 'error'
                },
                valueValidationHelpString: valueValidationHelpString,
                hasError: false
            };
        }
        return _this;
    }
    ComparisonFilter.getDerivedStateFromProps = function (nextProps, prevState) {
        return {
            filter: nextProps.filter
        };
    };
    /**
     *
     * @param previousProps
     */
    ComparisonFilter.prototype.componentDidUpdate = function (previousProps) {
        if (!_isEqual(previousProps.filter, this.props.filter)) {
            this.validateFilter();
        }
    };
    ComparisonFilter.prototype.componentDidCatch = function (error, errorInfo) {
        this.setState({
            hasError: true
        });
    };
    ComparisonFilter.prototype.render = function () {
        if (this.state.hasError) {
            return React.createElement("h1", null, "An error occured in the ComparisonFilter UI.");
        }
        var _a = this.props, attributeNameFilter = _a.attributeNameFilter, attributeLabel = _a.attributeLabel, attributePlaceholderString = _a.attributePlaceholderString, attributeNameMappingFunction = _a.attributeNameMappingFunction, attributeValidationHelpString = _a.attributeValidationHelpString, internalDataDef = _a.internalDataDef, hideAttributeType = _a.hideAttributeType, operatorNameMappingFunction = _a.operatorNameMappingFunction, operatorPlaceholderString = _a.operatorPlaceholderString, operatorLabel = _a.operatorLabel, operatorValidationHelpString = _a.operatorValidationHelpString, operatorTitleMappingFunction = _a.operatorTitleMappingFunction, showOperatorTitles = _a.showOperatorTitles, valueLabel = _a.valueLabel, valuePlaceholder = _a.valuePlaceholder, microUI = _a.microUI;
        var _b = this.state, attribute = _b.attribute, allowedOperators = _b.allowedOperators, filter = _b.filter, validateStatus = _b.validateStatus, valueValidationHelpString = _b.valueValidationHelpString;
        var className = 'gs-comparison-filter-ui';
        if (microUI) {
            className += ' micro';
        }
        return (React.createElement("div", { className: className },
            React.createElement(antd_1.Form, null,
                React.createElement(antd_1.Row, { gutter: 16, justify: "center" },
                    React.createElement(antd_1.Col, { span: 10, className: "gs-small-col" },
                        React.createElement(AttributeCombo_1.default, { value: filter ? filter[1] : undefined, internalDataDef: internalDataDef, onAttributeChange: this.onAttributeChange, attributeNameFilter: attributeNameFilter, attributeNameMappingFunction: attributeNameMappingFunction, label: attributeLabel, placeholder: attributePlaceholderString, validateStatus: validateStatus.attribute, help: attributeValidationHelpString, hideAttributeType: hideAttributeType })),
                    React.createElement(antd_1.Col, { span: 4, className: "gs-small-col" },
                        React.createElement(OperatorCombo_1.default, { value: filter ? filter[0] : undefined, internalDataDef: internalDataDef, onOperatorChange: this.onOperatorChange, operators: allowedOperators, operatorNameMappingFunction: operatorNameMappingFunction, placeholder: operatorPlaceholderString, label: operatorLabel, validateStatus: validateStatus.operator, help: operatorValidationHelpString, operatorTitleMappingFunction: operatorTitleMappingFunction, showTitles: showOperatorTitles })),
                    this.state.textFieldVisible ?
                        React.createElement(antd_1.Col, { span: 10, className: "gs-small-col" },
                            React.createElement(TextFilterField_1.default, { value: filter ? filter[2] : undefined, internalDataDef: internalDataDef, selectedAttribute: attribute, onValueChange: this.onValueChange, label: valueLabel, placeholder: valuePlaceholder, validateStatus: validateStatus.value, help: valueValidationHelpString })) :
                        null,
                    this.state.numberFieldVisible ?
                        React.createElement(antd_1.Col, { span: 10, className: "gs-small-col" },
                            React.createElement(NumberFilterField_1.default, { value: filter ? filter[2] : undefined, internalDataDef: internalDataDef, selectedAttribute: attribute, onValueChange: this.onValueChange, label: valueLabel, placeholder: valuePlaceholder, validateStatus: validateStatus.value, help: valueValidationHelpString })) :
                        null,
                    this.state.boolFieldVisible ?
                        React.createElement(antd_1.Col, { span: 10, className: "gs-small-col" },
                            React.createElement(BoolFilterField_1.default, { value: filter ? filter[2] : undefined, onValueChange: this.onValueChange, label: valueLabel })) :
                        null))));
    };
    /**
     * Default validation function for filter values.
     *
     * @param {string | number | boolean | null} newValue The new filter value
     * @param {Data} internalDataDef The internal data object
     * @param {string} selectedAttribute The currently seledted attribute field
     */
    ComparisonFilter.validateValue = function (newValue, internalDataDef, selectedAttribute) {
        var isValid = true;
        var errorMsg = '';
        // read out attribute type
        var attrType = _get(internalDataDef, "schema.properties[" + selectedAttribute + "].type");
        switch (attrType) {
            case 'number':
                // detect min / max from schema
                var minVal = _get(internalDataDef, "schema.properties[" + selectedAttribute + "].minimum");
                var maxVal = _get(internalDataDef, "schema.properties[" + selectedAttribute + "].maximum");
                if (!isNaN(minVal) && !isNaN(maxVal)) {
                    if (typeof newValue !== 'number') {
                        isValid = false;
                        errorMsg = 'Please enter a number';
                    }
                    else if (newValue < minVal) {
                        isValid = false;
                        errorMsg = 'Minimum Value is ' + minVal;
                    }
                    else if (newValue > maxVal) {
                        isValid = false;
                        errorMsg = 'Maximum Value is ' + maxVal;
                    }
                }
                break;
            default:
                break;
        }
        return {
            isValid: isValid,
            errorMsg: errorMsg
        };
    };
    ComparisonFilter.defaultProps = {
        filter: ['==', '', null],
        hideAttributeType: false,
        attributeNameFilter: function () { return true; },
        attributeLabel: undefined,
        attributePlaceholderString: undefined,
        attributeValidationHelpString: undefined,
        attributeNameMappingFunction: function (n) { return n; },
        operatorLabel: undefined,
        showOperatorTitles: true,
        operatorPlaceholderString: undefined,
        operatorValidationHelpString: undefined,
        operatorNameMappingFunction: function (n) { return n; },
        operatorTitleMappingFunction: function (t) { return t; },
        valueLabel: undefined,
        valuePlaceholder: undefined,
        valueValidationHelpString: undefined,
        onValidationChanged: function () { return false; },
        validators: {
            attribute: function (attributeName) { return !_isEmpty(attributeName); },
            operator: function (operatorName) { return !_isEmpty(operatorName); },
            value: ComparisonFilter.validateValue
        },
        microUI: false
    };
    return ComparisonFilter;
}(React.Component));
exports.ComparisonFilter = ComparisonFilter;
exports.default = ComparisonFilter;
//# sourceMappingURL=ComparisonFilter.js.map